import { get, patch, post, remove } from '@/api/base'

const orderTemplatesApi = {
  get: async orderTemplateUuid => {
    const response = await get({ path: `order_templates/${orderTemplateUuid}` })
    return response.success ? response.data.order_template : null
  },
  getPage: async ({ companyUuid, page }) => {
    const response = await get({
      path: 'order_templates',
      params: {
        company_uuid: companyUuid,
        page,
      },
    })

    return response.success
      ? {
          ...response,
          orderTemplates: response.data.order_templates,
          pagination: response.data.meta.pagination,
        }
      : response
  },
  create: async params => {
    const response = await post({ path: 'order_templates', params })
    return response.success ? response.data.order_template : null
  },
  update: async (orderTemplateUuid, params) => {
    return await patch({ path: `order_templates/${orderTemplateUuid}`, params })
  },
  delete: async orderTemplateUuid => {
    return await remove({ path: `order_templates/${orderTemplateUuid}` })
  },
}

export default orderTemplatesApi
